<mat-card-content>
  <div class="ps-grid-4-col">
    <div *ngIf="!mobile"></div>
    <div *ngIf="!mobile">{{ _previousStatus?.TIMELABEL }}</div>
    <div></div>
    <div>{{ _previousStatus?.TIMELABEL }}</div>
    <mat-form-field>
      <mat-label>Datum ETA erhalten</mat-label>
      <input
        matInput
        [matDatepicker]="pickerLastETA"
        [(ngModel)]="_currentStatus.DATE_LAST_ETA"
        (ngModelChange)="onChange()"
        disabled />
      <mat-datepicker-toggle matSuffix [for]="pickerLastETA">
        <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #pickerLastETA [disabled]="!editable"></mat-datepicker>
    </mat-form-field>

    <div
      *ngIf="_previousStatus"
      [ngClass]="{
        different: isDifferent(
          _previousStatus.DATE_LAST_ETA,
          _currentStatus.DATE_LAST_ETA
        ),
      }">
      {{ _previousStatus.DATE_LAST_ETA | date }}
    </div>
    <div *ngIf="!_previousStatus">Noch kein Wert gesetzt!</div>

    <mat-form-field>
      <mat-label>Datum Blecheingang</mat-label>
      <input
        matInput
        [matDatepicker]="pickerMatReceipt"
        [(ngModel)]="_currentStatus.DATE_MAT_RECEIPT"
        (ngModelChange)="onChange()"
        disabled />
      <mat-datepicker-toggle matSuffix [for]="pickerMatReceipt">
        <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #pickerMatReceipt [disabled]="!editable"></mat-datepicker>
    </mat-form-field>

    <div
      *ngIf="_previousStatus"
      [ngClass]="{
        different: isDifferent(
          _previousStatus?.DATE_MAT_RECEIPT,
          _currentStatus.DATE_MAT_RECEIPT
        ),
      }">
      {{ _previousStatus?.DATE_MAT_RECEIPT | date }}
    </div>
    <div *ngIf="!_previousStatus">Noch kein Wert gesetzt!</div>

    <mat-form-field>
      <mat-label>Eingang Fertigungsdaten</mat-label>
      <input
        matInput
        [matDatepicker]="pickerMAFData"
        [(ngModel)]="_currentStatus.DATE_MAF_DATA"
        (ngModelChange)="onChange()"
        disabled />
      <mat-datepicker-toggle matSuffix [for]="pickerMAFData">
        <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #pickerMAFData [disabled]="!editable"></mat-datepicker>
    </mat-form-field>

    <div
      *ngIf="_previousStatus"
      [ngClass]="{
        different: isDifferent(
          _previousStatus.DATE_MAF_DATA,
          _currentStatus.DATE_MAF_DATA
        ),
      }">
      {{ _previousStatus?.DATE_MAF_DATA | date }}
    </div>
    <div *ngIf="!_previousStatus">Noch kein Wert gesetzt!</div>

    <mat-form-field>
      <mat-label>Konstruktion/Methode fertig</mat-label>
      <input
        matInput
        [matDatepicker]="pickerCadFinished"
        [(ngModel)]="_currentStatus.DATE_CAD_FINISHED"
        (ngModelChange)="onChange()"
        disabled />
      <mat-datepicker-toggle matSuffix [for]="pickerCadFinished">
        <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker
        #pickerCadFinished
        [disabled]="!editable"></mat-datepicker>
    </mat-form-field>

    <div
      *ngIf="_previousStatus"
      [ngClass]="{
        different: isDifferent(
          _previousStatus.DATE_CAD_FINISHED,
          _currentStatus.DATE_CAD_FINISHED
        ),
      }">
      {{ _previousStatus?.DATE_CAD_FINISHED | date }}
    </div>
    <div *ngIf="!_previousStatus">Noch kein Wert gesetzt!</div>

    <mat-form-field>
      <mat-label>Guss / Stahl letzte AFO</mat-label>
      <input
        matInput
        [matDatepicker]="pickerLastOp"
        [(ngModel)]="_currentStatus.DATE_CAST_LAST_OP"
        (ngModelChange)="onChange()"
        disabled />
      <mat-datepicker-toggle matSuffix [for]="pickerLastOp">
        <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #pickerLastOp [disabled]="!editable"></mat-datepicker>
    </mat-form-field>

    <div
      *ngIf="_previousStatus"
      [ngClass]="{
        different: isDifferent(
          _previousStatus.DATE_CAST_LAST_OP,
          _currentStatus.DATE_CAST_LAST_OP
        ),
      }">
      {{ _previousStatus?.DATE_CAST_LAST_OP | date }}
    </div>
    <div *ngIf="!_previousStatus">Noch kein Wert gesetzt!</div>

    <mat-form-field>
      <mat-label>Start WKZ Fräsen 1. AFO</mat-label>
      <input
        matInput
        [matDatepicker]="pickerMillingFirstOp"
        [(ngModel)]="_currentStatus.DATE_DIE_MIILING_FIRST_OP"
        (ngModelChange)="onChange()"
        disabled />
      <mat-datepicker-toggle matSuffix [for]="pickerMillingFirstOp">
        <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker
        #pickerMillingFirstOp
        [disabled]="!editable"></mat-datepicker>
    </mat-form-field>

    <div
      *ngIf="_previousStatus"
      [ngClass]="{
        different: isDifferent(
          _previousStatus.DATE_DIE_MIILING_FIRST_OP,
          _currentStatus.DATE_DIE_MIILING_FIRST_OP
        ),
      }">
      {{ _previousStatus?.DATE_DIE_MIILING_FIRST_OP | date }}
    </div>
    <div *ngIf="!_previousStatus">Noch kein Wert gesetzt!</div>

    <mat-form-field>
      <mat-label>Ende WKZ Fräsen letzte AFO</mat-label>
      <input
        matInput
        [matDatepicker]="pickerMillingLastOp"
        [(ngModel)]="_currentStatus.DATE_DIE_MIILING_LAST_OP"
        (ngModelChange)="onChange()"
        disabled />
      <mat-datepicker-toggle matSuffix [for]="pickerMillingLastOp">
        <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker
        #pickerMillingLastOp
        [disabled]="!editable"></mat-datepicker>
    </mat-form-field>

    <div
      *ngIf="_previousStatus"
      [ngClass]="{
        different: isDifferent(
          _previousStatus.DATE_DIE_MIILING_LAST_OP,
          _currentStatus.DATE_DIE_MIILING_LAST_OP
        ),
      }">
      {{ _previousStatus?.DATE_DIE_MIILING_LAST_OP | date }}
    </div>
    <div *ngIf="!_previousStatus">Noch kein Wert gesetzt!</div>

    <mat-form-field>
      <mat-label>Werkzeug Einbau 1. AFO fertig</mat-label>
      <input
        matInput
        [matDatepicker]="pickerAssemblyFirstOp"
        [(ngModel)]="_currentStatus.DATE_DIE_ASSEMBLY_FIRST_OP"
        (ngModelChange)="onChange()"
        disabled />
      <mat-datepicker-toggle matSuffix [for]="pickerAssemblyFirstOp">
        <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker
        #pickerAssemblyFirstOp
        [disabled]="!editable"></mat-datepicker>
    </mat-form-field>

    <div
      *ngIf="_previousStatus"
      [ngClass]="{
        different: isDifferent(
          _previousStatus.DATE_DIE_ASSEMBLY_FIRST_OP,
          _currentStatus.DATE_DIE_ASSEMBLY_FIRST_OP
        ),
      }">
      {{ _previousStatus?.DATE_DIE_ASSEMBLY_FIRST_OP | date }}
    </div>
    <div *ngIf="!_previousStatus">Noch kein Wert gesetzt!</div>

    <mat-form-field>
      <mat-label>Teile Abpressung 1. Ziehteil</mat-label>
      <input
        matInput
        [matDatepicker]="pickerPressStartFirst"
        [(ngModel)]="_currentStatus.DATE_PRESS_PART_FIRST"
        (ngModelChange)="onChange()"
        disabled />
      <mat-datepicker-toggle matSuffix [for]="pickerPressStartFirst">
        <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker
        #pickerPressStartFirst
        [disabled]="!editable"></mat-datepicker>
    </mat-form-field>

    <div
      *ngIf="_previousStatus"
      [ngClass]="{
        different: isDifferent(
          _previousStatus.DATE_PRESS_PART_FIRST,
          _currentStatus.DATE_PRESS_PART_FIRST
        ),
      }">
      {{ _previousStatus?.DATE_PRESS_PART_FIRST | date }}
    </div>
    <div *ngIf="!_previousStatus">Noch kein Wert gesetzt!</div>

    <mat-form-field>
      <mat-label>Teile am Laser</mat-label>
      <input
        matInput
        [matDatepicker]="pickerLaserPart"
        [(ngModel)]="_currentStatus.DATE_LASER_PART"
        (ngModelChange)="onChange()"
        disabled />
      <mat-datepicker-toggle matSuffix [for]="pickerLaserPart">
        <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #pickerLaserPart [disabled]="!editable"></mat-datepicker>
    </mat-form-field>

    <div
      *ngIf="_previousStatus"
      [ngClass]="{
        different: isDifferent(
          _previousStatus?.DATE_LASER_PART,
          _currentStatus?.DATE_LASER_PART
        ),
      }">
      {{ _previousStatus?.DATE_LASER_PART | date }}
    </div>
    <div *ngIf="!_previousStatus">Noch kein Wert gesetzt!</div>

    <mat-form-field>
      <mat-label>Datum Messprotokoll</mat-label>
      <input
        matInput
        [matDatepicker]="pickerMeasureProtocol"
        [(ngModel)]="_currentStatus.DATE_MEASURE_PROTOCOL"
        (ngModelChange)="onChange()"
        disabled />
      <mat-datepicker-toggle matSuffix [for]="pickerMeasureProtocol">
        <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker
        #pickerMeasureProtocol
        [disabled]="!editable"></mat-datepicker>
    </mat-form-field>

    <div
      *ngIf="_previousStatus"
      [ngClass]="{
        different: isDifferent(
          _previousStatus?.DATE_MEASURE_PROTOCOL,
          _currentStatus?.DATE_MEASURE_PROTOCOL
        ),
      }">
      {{ _previousStatus?.DATE_MEASURE_PROTOCOL | date }}
    </div>
    <div *ngIf="!_previousStatus">Noch kein Wert gesetzt!</div>

    <mat-form-field>
      <mat-label>Q Schleife</mat-label>
      <input
        matInput
        [matDatepicker]="pickerQ"
        [(ngModel)]="_currentStatus.DATE_QS_LOOP"
        (ngModelChange)="onChange()"
        disabled />
      <mat-datepicker-toggle matSuffix [for]="pickerQ">
        <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #pickerQ [disabled]="!editable"></mat-datepicker>
      <div
        style="padding-top: 8px"
        *ngIf="_currentStatus.TEIL_QA_DATE; else NO_QA_DATE">
        geplanter QS-Termin: {{ _currentStatus.TEIL_QA_DATE | date }}
      </div>
      <ng-template #NO_QA_DATE>
        <div style="padding-top: 8px">noch kein QS-Termin geplant!</div>
      </ng-template>
    </mat-form-field>

    <div
      *ngIf="_previousStatus"
      [ngClass]="{
        different: isDifferent(
          _previousStatus.PREV_DATE_QS_LOOP,
          _currentStatus.PREV_DATE_QS_LOOP
        ),
      }">
      {{ _previousStatus?.PREV_DATE_QS_LOOP | date }}
    </div>
    <div *ngIf="!_previousStatus">Noch kein Wert gesetzt!</div>

    <mat-form-field>
      <mat-label>Letzte Formänderung</mat-label>
      <input
        matInput
        [matDatepicker]="pickerLastChange"
        [(ngModel)]="_currentStatus.DATE_LAST_CHANGE"
        (ngModelChange)="onChange()"
        disabled />
      <mat-datepicker-toggle matSuffix [for]="pickerLastChange">
        <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #pickerLastChange [disabled]="!editable"></mat-datepicker>
    </mat-form-field>

    <div
      *ngIf="_previousStatus"
      [ngClass]="{
        different: isDifferent(
          _previousStatus.DATE_LAST_CHANGE,
          _currentStatus.DATE_LAST_CHANGE
        ),
      }">
      {{ _previousStatus?.DATE_LAST_CHANGE | date }}
    </div>
    <div *ngIf="!_previousStatus">Noch kein Wert gesetzt!</div>

    <mat-form-field>
      <mat-label>Ist Wert Blechdicke (mit Dezimalpunkt .)</mat-label>
      <input
        [disabled]="!editable"
        matInput
        [(ngModel)]="_currentStatus.NUM_MAT_THICKNESS"
        (ngModelChange)="onChange()" />
    </mat-form-field>

    <div
      *ngIf="_previousStatus"
      [ngClass]="{
        different: isDifferent(
          _previousStatus.NUM_MAT_THICKNESS,
          _currentStatus.NUM_MAT_THICKNESS
        ),
      }">
      {{ _previousStatus?.NUM_MAT_THICKNESS }}
    </div>
    <div *ngIf="!_previousStatus">Noch kein Wert gesetzt!</div>

    <mat-form-field>
      <mat-label>Schwierigkeit</mat-label>
      <mat-select
        [disabled]="!editable"
        [(ngModel)]="_currentStatus.NUM_COMPLEXITY"
        (selectionChange)="onChange()"
        [compareWith]="compareComplexity">
        <mat-option value="1">1</mat-option>
        <mat-option value="2">2</mat-option>
        <mat-option value="3">3</mat-option>
      </mat-select>
    </mat-form-field>

    <div
      *ngIf="_previousStatus"
      [ngClass]="{
        different: isDifferent(
          _previousStatus.NUM_COMPLEXITY,
          _currentStatus.NUM_COMPLEXITY
        ),
      }">
      {{ _previousStatus?.NUM_COMPLEXITY }}
    </div>
    <div *ngIf="!_previousStatus">Noch kein Wert gesetzt!</div>

    <mat-form-field>
      <mat-label>Kommentar</mat-label>
      <input
        matInput
        [disabled]="!editable"
        [(ngModel)]="_currentStatus.TEXT_COMMENT"
        (ngModelChange)="onChange()" />
    </mat-form-field>

    <div
      *ngIf="_previousStatus"
      [ngClass]="{
        different: isDifferent(
          _previousStatus.TEXT_COMMENT,
          _currentStatus.TEXT_COMMENT
        ),
      }">
      {{ _previousStatus?.TEXT_COMMENT }}
    </div>
    <div *ngIf="!_previousStatus">Noch kein Wert gesetzt!</div>

    <div
      *ngIf="_previousStatus"
      [ngClass]="{
        different: isDifferent(
          _previousStatus.PRODUCTION_PROGRESS,
          _currentStatus.PRODUCTION_PROGRESS
        ),
      }">
      {{ _previousStatus?.PRODUCTION_PROGRESS }}
    </div>
    <div *ngIf="!_previousStatus">Noch kein Wert gesetzt!</div>
  </div>
</mat-card-content>
